import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';

@Component({
  selector: 'app-facets-button',
  templateUrl: './facets-button.component.html',
  styleUrls: ['./facets-button.component.scss'],
})
export class FacetsButtonComponent implements OnInit {
  @Input() public totalResults: number;
  @Input() public leftCount: number;
  @Input() public showAllAvailable: boolean;
  @Input() public facetName: string;
  @Input() public facetPluralName: string;

  @Input()
  public set showedFacetsCount(showedFacetsCount: number) {
    this._showedFacetsCount = showedFacetsCount;
    this.defineValues();
  }

  @Output() public showMore: EventEmitter<void> = new EventEmitter();
  @Output() public showFewer: EventEmitter<void> = new EventEmitter();
  @Output() public showAll: EventEmitter<void> = new EventEmitter();

  public AMOUNT_FOR_OPEN_WINDOW = 16;
  public AMOUNT_FOR_DISPLAY_ON_FACET_PANEL = 5;
  public isShowMore: any;
  public isShowFewer: any;
  public isShowAll: any;
  private _showedFacetsCount: number;

  public toggleEvent() {
    if (this.isShowFewer) {
      this.showFewer.emit(null);
    } else if (this.isShowAll) {
      this.showAll.emit(null);
    } else {
      this.showMore.emit(null);
    }
  }

  public ngOnInit() {
    this.defineValues();
  }

  private defineValues() {
    this.isShowMore = this.totalResults < this.AMOUNT_FOR_OPEN_WINDOW
      && this._showedFacetsCount <= this.AMOUNT_FOR_DISPLAY_ON_FACET_PANEL
      && this.totalResults !== this._showedFacetsCount;
    this.isShowFewer = this.totalResults > this.AMOUNT_FOR_DISPLAY_ON_FACET_PANEL && this._showedFacetsCount > this.AMOUNT_FOR_DISPLAY_ON_FACET_PANEL;
    this.isShowAll = this.totalResults >= this.AMOUNT_FOR_OPEN_WINDOW && this.showAllAvailable;
  }
}
